import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import { style } from '../../../components/pdf/fontstyles';

const styles = StyleSheet.create({
 
  certificateItem: {
    marginBottom: 20,
    lineHeight: 1.5,
    fontSize: 11
  },
  signatureContainer: {
    marginTop: 40,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
});

const GenralCertificate = ({ result }) => {
  const getNextDay = (dateStr) => {
    if (!dateStr) return 'N/A';
    const [d, m, y] = dateStr.split('/');
    return new Date(y, m-1, +d+1).toLocaleDateString('en-GB');
  };

  const nextDay = getNextDay(result?.dateOfRetirement);

  return (
    <View size="A4" style={style.page}>
      <Text style={[style.title, style.ArialBlack]}>CERTIFICATES</Text>
      <View style={style.solidLine} />

      {/* Certificate Items */}
      <Text style={styles.certificateItem}>
        1. Certified that the service of {result.employeeName}, {result.designation} for the period from {result.dateOfAppointment} to {result.dateOfRetirement} has been verified from pay bills and muster roll & found to be correct.
      </Text>

      <Text style={styles.certificateItem}>
        2. Certified that {result.employeeName}, {result.designation} is confirmed in this college/Sanstha on {result.dateOfConfirmation}.
      </Text>

      <Text style={styles.certificateItem}>
        3. Certified that {result.institutionName} is Recognized and 100% aided by the School Education and Sports Department during the period when {result.employeeName} rendered her services in this Jr. College.
      </Text>

      <Text style={styles.certificateItem}>
        4. Certified that there is no break in the entire period from {result.dateOfAppointment} to {result.dateOfRetirement}. Certified that there is no period of no payment during the whole service.
      </Text>

      <Text style={styles.certificateItem}>
        5. Certified that the service period from {result.dateOfAppointment} to {result.dateOfRetirement} rendered by him are full time Asstt Teacher under the recognized by the Edn. Deptt. of Govt. of Maharashtra.
      </Text>

      <Text style={styles.certificateItem}>
        6. Certified that the pay fixed as on .............., ................, ..............., ............... have been verified by the Sr. Audit Squad Education Dept.
      </Text>

      <Text style={styles.certificateItem}>
        7. This is to certify that {result.employeeName}, {result.designation} being date of birth {result.dateOfBirth} completed 58 Years of age and hence date of retirement is {result.dateOfRetirement}
      </Text>

     
      {/* Signatures */}
      <View style={styles.signatureContainer}>
        <View>
          <Text>Place: {result.placeOfRetirement}</Text>
          <Text>Date: </Text>
        </View>

          <Text style={style.signature}>Head of Office</Text>

      </View>
    </View>
  );
};

export default GenralCertificate;